import { render, staticRenderFns } from "./basket.vue?vue&type=template&id=40e3dcc0&scoped=true"
import script from "./basket.vue?vue&type=script&lang=js"
export * from "./basket.vue?vue&type=script&lang=js"
import style0 from "./basket.vue?vue&type=style&index=0&id=40e3dcc0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e3dcc0",
  null
  
)

export default component.exports